import { gettext } from '@eventbrite/i18n';

export const ORGANIZER_COOKIE = 'ebOrganizerId';

export const GET_ORG_ERROR_NOTIFICATION = gettext(
    'There was an error getting the organizer info from the server. Please try again in a few minutes',
);
